import loadable from '@loadable/component';

export default {
    tenant_footer: loadable(() => import('./FooterTenantModule')),
    tenant_header: loadable(() => import('./HeaderTenantModule')),
};
